<template>
  <b-layout :colors="$site.colors" :header-title="$t('pages.pass.complete.title')" :header-back-route="homeRoute">
    <b-container class="mt-12">
      <b-summary v-if="customerPass">
        <template #summary>
          <b-card class="text-secondary">
            <img v-if="passImage" :src="passImage" class="mb-4 rounded" />

            <h3 class="font-semibold text-xl mt-6 mb-6">
              {{ customerPass.pass.name }}
            </h3>
            <h6 class="text-xs font-weight-light mb-2">
              {{ $site.location.title }}
            </h6>
          </b-card>
        </template>

        <div>
          <b-card :title="$t('pages.pass.complete.allDone')" class="mb-3">
            <p class="text-sm text-secondary mb-2">
              {{ $t('pages.pass.complete.allDone', {customer: customerPass.customer.firstName}) }}
            </p>

            <p class="text-sm text-secondary">
              {{ $t('pages.pass.complete.passReadyToUse', {pass: customerPass.pass.name}) }}
            </p>
          </b-card>
        </div>
      </b-summary>
    </b-container>
  </b-layout>
</template>

<script>
export default defineNuxtComponent({
  /* data() {
    return {
      customerPass: null
    }
  }, */
  computed: {
    homeRoute() {
      return this.$store.getters.homeRoute || { path: '/' }
    },
    passImage() {
      if (this.customerPass.images) {
        return this.customerPass.images.large
      } else if (this.$site.images.pass) {
        return this.$site.images.pass.large
      }
      return null
    }
  },
  async asyncData () {
    const route = useRoute()
    const { $api } = useNuxtApp()

    const query = route.query

    try {
      const response = await $api.pass.customerPass(query.id, query.signature)

      return {
        customerPass: response.customerPass
      }
    } catch (error) {
      console.error(error)
      return {
        customerPass: null
      }
    }
  },
  mounted() {
    if (this.$site.isEmbed && window.parent) {
      window.postRobot?.send(window.parent, 'bookapp.event.gift.pass.purchased', this.customerPass)
    }

    const { gtag } = useGtag()
    
    gtag(
      'event',
      'complete_pass_purchase',
      {
        event_category: 'purchase',
        event_label: 'New Pass Purchase'
      }
    )
  }
})
</script>
